module.exports = __webpack_public_path__ + "img/make-impact-kailash.22f90ab0.jpg";